export default __webpack_public_path__ + "static/media/client-22.6fd15b31.png";